const channels = [
  {
    id: 1,
    name: 'Learn Spanish with SpanishPod101.com',
    url: 'https://www.youtube.com/@spanishpod101',
    videos: [
      'https://www.youtube.com/watch?v=GEDc_QG9OhA',
      'https://www.youtube.com/watch?v=4zRy2-tX0J0',
      'https://www.youtube.com/watch?v=RBOSPBhUsxg'
    ]
  },
  {
    id: 2,
    name: 'Butterfly Spanish',
    url: 'https://www.youtube.com/@ButterflySpanish',
    videos: [
      'https://www.youtube.com/watch?v=o3d0OHTHTNc',
      'https://www.youtube.com/watch?v=6_5FnCLLYoA',
      'https://www.youtube.com/watch?v=2v1BnjusSrI'
    ],
    profileLinks: [
      {
        'label': 'Go to my website!',
        'url': 'https://www.butterflyspanish.com/'
      },
      {
        'label': 'Donate so I can produce more!',
        'url': 'https://www.paypal.com/paypalme/ButterflySpanish'
      },
      {
        'label': 'Facebook',
        'url': 'https://www.facebook.com/ButterflySpanish'
      },
      {
        'label': 'Twitter',
        'url': 'https://x.com/ontheflySpanish'
      },
    ]
  },
  {
    id: 3,
    name: 'Real Fast Spanish',
    url: 'https://www.youtube.com/@realfastspanish',
    videos: [
      'https://www.youtube.com/watch?v=17BV5jmtYyU',
      'https://www.youtube.com/watch?v=BnTqVmKHg7o',
      'https://www.youtube.com/watch?v=_d9Z9V21zX0',
      'https://www.youtube.com/watch?v=Qj46j30eP54',
      'https://www.youtube.com/watch?v=6Zr4nMsoLzI',
      'https://www.youtube.com/watch?v=aITFeidyl8Q'
    ]
  },
  {
    id: 4,
    name: 'Spanish by Gala',
    url: 'https://www.youtube.com/@spanishbygala',
    videos: [
      'https://www.youtube.com/watch?v=th5Z-_uXwFg',
      'https://www.youtube.com/watch?v=8k9UGrUHiNg',
      'https://www.youtube.com/watch?v=4Q6p416BT5o'
    ]
  },
  {
    id: 5,
    name: 'superholly',
    url: 'https://www.youtube.com/channel/UC7ZWBllAI9hFTGpCT6fYcYQ',
    videos: [
      'https://www.youtube.com/watch?v=LR7RlGqcXEY'
    ]
  },
  {
    id: 6,
    name: 'Spanish After Hours',
    url: 'https://www.youtube.com/channel/UCfG2VhlQgy5bHGmkpeKcjVA',
    videos: [
      'https://www.youtube.com/watch?v=3nb_hjv5Y24'
    ]
  },
  {
    id: 7,
    name: 'Español Automático, con Karo Martínez',
    url: 'https://www.youtube.com/c/EspanolAutomatico',
    videos: [
      'https://www.youtube.com/watch?v=LOoGjDqTDIk'
    ]
  },
  {
    id: 8,
    name: 'Why Not Spanish?',
    url: 'https://www.youtube.com/@WhyNotSpanish',
    videos: [
      'https://www.youtube.com/watch?v=Q_VCOgWVYP0'
    ]
  },
  {
    id: 9,
    name: 'Dreaming Spanish',
    url: 'https://www.youtube.com/c/DreamingSpanish/',
    videos: [
      'https://www.youtube.com/watch?v=XtGKTkHLDIc',
      'https://www.youtube.com/watch?v=aZnXBVrpeq0',
      'https://www.youtube.com/watch?v=1YyfbhkDlJA'
    ],
    profileLinks: [
      {
        'label': 'Website',
        'url': 'https://www.dreamingspanish.com/'
      },
      {
        'label': 'Patreon',
        'url': 'https://www.patreon.com/DreamingSpanish'
      },
      {
        'label': 'PayPal',
        'url': 'https://www.paypal.com/paypalme/DreamingSpanish'
      },
    ]
  },
  {
    id: 10,
    name: 'Español con Juan',
    url: 'https://www.youtube.com/c/1001reasonstolearnspanishwithus',
    videos: [
      'https://www.youtube.com/watch?v=n3v2fs2xIsk'
    ]
  },
  {
    id: 11,
    name: 'Deliberate Spanish',
    url: 'https://www.youtube.com/c/NachoTimeSpanish',
    videos: [
      'https://www.youtube.com/watch?v=UCrGqRhu8Dc'
    ]
  },
  {
    id: 12,
    name: 'Spring Spanish - Learn Spanish with Chunks',
    url: 'https://www.youtube.com/c/SpringSpanish/',
    videos: [
      'https://www.youtube.com/watch?v=n1c1whHwWTM'
    ]
  },
  {
    id: 13,
    name: 'BookBox Spanish',
    url: 'https://www.youtube.com/@BookBoxSpanish',
    videos: [
      'https://www.youtube.com/watch?v=e6jR5IB6FZw',
      'https://www.youtube.com/watch?v=kLLswsCKkh0',
      'https://www.youtube.com/watch?v=hoHDbp-LwWw',
      'https://www.youtube.com/watch?v=nEfBdohVj-o',
      'https://www.youtube.com/watch?v=aKI9hHHMXq4',
      'https://www.youtube.com/watch?v=Rwhx9jau1WY'
    ],
    profileLinks: [
      {
        'label': 'Facebook',
        'url': 'https://www.facebook.com/BookBoxInc/'
      },
      {
        'label': 'Go to my website!',
        'url': 'https://bookbox.com/'
      },
      {
        'label': 'YouTube channel',
        'url': 'https://www.youtube.com/@BookBoxSpanish'
      }
    ]
  },
]

export default channels


// WEBPACK FOOTER //
// ./src/browser/channels/languages/spanish.js